import { jsx } from "react/jsx-runtime";
import cx from "classnames";
import {
  TypographyPrefixedContext
} from "@ingka/typography-shared";
const Text = (props) => {
  const {
    prefix = "",
    className,
    tagName = "div",
    textStyle = "Body.M",
    children,
    ...other
  } = props;
  const typography = new TypographyPrefixedContext();
  typography.prefix = prefix;
  const [textStyleGroup, textStyleSize] = textStyle.split(".");
  const prefixedClassnames = typography[textStyleGroup][textStyleSize];
  const baseClass = `${prefix}text`;
  const classes = cx(
    baseClass,
    prefixedClassnames,
    ["Body", "Caption"].includes(textStyleGroup) ? `${baseClass}--lighter` : "",
    className
  );
  const Tag = tagName || "div";
  return /* @__PURE__ */ jsx(Tag, { ...other, className: classes, children });
};
var Text_default = Text;
export {
  Text_default as default
};
